import { render, staticRenderFns } from "./liveDetail.vue?vue&type=template&id=bcbda0ce&scoped=true&"
import script from "./liveDetail.vue?vue&type=script&lang=ts&"
export * from "./liveDetail.vue?vue&type=script&lang=ts&"
import style0 from "./liveDetail.vue?vue&type=style&index=0&id=bcbda0ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbda0ce",
  null
  
)

export default component.exports